import React from 'react';
import Competitor from 'components/presentation/Competitor';
import Organisation from 'components/presentation/Organisation';

import { NocMemo as Noc } from 'components/presentation/Noc';
import Label from "components/general/Label"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faStop, faArrowDown, faArrowUp,
    faCaretDown, faCaretRight, faCamera, faPlusCircle, faMinusCircle
} from "@fortawesome/free-solid-svg-icons";
import Movement from "components/presentation/Movement"
import { findArray, isParalympic, CompetitionFromStore, RscFromStore } from 'helpers/utils'
import SportCode from 'components/common/SportCode'
import { getRscObject } from 'helpers/rsc';
import Horse from 'components/presentation/Horse';
import { useViewport } from 'components/general/useViewPort';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";


/*
Change background color celll conditional

columns: [{
  Header: 'Column',
  accessor: 'specific_column',
  getProps: {
    (state, rowInfo) => ({
      style: {
        backgroundColor: (rowInfo.row.specific_column===1?'red':null)
      }
    })
  }
}]

*/


export const CellRank = React.memo(({ node, hasRankEqual }) => {
    let photo = node?.extendedResults ? node?.extendedResults.filter(row => (row?.er_code === 'PHOTO' && row?.er_value === 'P')).map((val) => { return (val?.er_value) }) : ''
    let rank = node?.resultType !== 'IRM'
        ? node?.resultIrm !== 'OTL'
            ? node?.resultRank
            : ''
        : ''
    rank = rank ? rank : '' //remove undefined
    let resp = (photo && photo.length) > 0
        ? <FontAwesomeIcon className="font-icon" icon={faCamera} />
        : (hasRankEqual && node?.resultRankEqual === 'Y') ? `=${rank}` : rank
    return (resp)
}
);


export const CellDiff = React.memo(({ node }) => {
    let diff = node?.diff && node?.resultType !== 'IRM' && node?.resultIrm !== 'REL' && node?.resultIrm !== 'OTL'
        ? node?.diff
        : node?.resultIrm === 'REL' || node?.resultIrm === 'OTL'
            ? node?.resultIrm
            : ''
    return (diff)
}
);

export const CellDiffOws = React.memo(({ node }) => {
    let diff = node?.diff && node?.resultType !== 'IRM' && node?.resultIrm !== 'REL' && node?.resultIrm !== 'OTL'
        ? node?.diff
        : ''
    return (diff)
}
);


export const CellResult = React.memo(({ irm }) => {
    return (irm)
});

//Added Lane Infringement
export const CellCardsFalseStart = React.memo(({ extendedResults, participant }) => {
    let cards = extendedResults.filter(row => row.er_code === 'YC' || row.er_code === 'RC' || row.er_code === 'YRC' || row.er_code === 'PENALTY').map((val, key) => {
        let penalty = val.er_code === 'PENALTY'
            ? val.er_value === 'Y'
                ? <> <FontAwesomeIcon key={participant + '_Card' + key} className='icon-yellow' icon={faStop} /></>
                : <> <FontAwesomeIcon key={participant + '_Card' + key} className='icon-red' icon={faStop} /> </>
            : <>
                {val.er_code === 'YC'
                    ? <> <FontAwesomeIcon key={participant + '_Card' + key} className='icon-yellow' icon={faStop} /></>
                    : <> <FontAwesomeIcon key={participant + '_Card' + key} className='icon-red' icon={faStop} /> </>
                }
            </>
        return (penalty)
    })

    let falseStarts = extendedResults.filter(row => row.er_code === 'FALSE_START').map((val, key) => {
        let value2 = val.er_value2 ? '(' + val.er_value2 + ')' : "";
        return (<div key={participant + '_FalseStart_' + key}> {val.er_value}{value2}</div>)
    })

    let laneInfrigement = extendedResults.filter(row => row.er_code === 'LANE_INFRINGE').map((val, key) => {
        return (<div key={participant + '_LaneInfringe_' + key}>{val.er_value}</div>)
    })

    let resp = (cards.length > 0 || falseStarts.length > 0 || laneInfrigement.length > 0) ? <>{cards}  {falseStarts} {laneInfrigement}</> : ''
    return (resp)
});




export function ColumnStartOrder({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-5',
    label = 'LabelStartOrder',
    accessor = 'startSortOrder',
    remove = false
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: accessor,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'StartOrder',
            remove: remove,
            Cell: (props) => (
                props.cell.row.original.startOrder
            )
        }
    )
}

export function ColumnStartTime({
    disableSort = true,
    className = 'text-center',
    headerClassName = 'text-center w-10',
    label = 'HeaderStartTime',
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: (props) => (
                props.eventUnitEntries
                    ? props.eventUnitEntries.find(row => row.eue_code === 'START_TIME')?.eue_value
                    : ''
            ),
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'StartTime',
            Cell: (props) => (
                props.cell.row.original.eventUnitEntries
                    ? props.cell.row.original.eventUnitEntries.find(row => row.eue_code === 'START_TIME')?.eue_value
                    : ''
            )
        }
    )
}

export function ColumnRank({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-5 text-nowrap align-middle',
    label = 'HeaderRank',
    remove = false,
    hasRankEqual = false
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'sortOrder',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Rank',
            remove: remove,
            Cell: (props) => (
                //Si mandas todas las propiedades de la fila como esta cambia hace que se repinte 
                <CellRank node={props.cell.row.original} hasRankEqual={hasRankEqual}></CellRank>

            )
        }
    )
}

export function ColumnRankNoResult({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-5 text-nowrap',
    label = 'HeaderRank',
    isEventRanking = false,
    isPoolStandings = false
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'sortOrder',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'RankNoResult',
            Cell: (props) => {
                let discipline = getRscObject(RscFromStore()).discipline
                let row = props.cell.row.original
                let rank = row?.resultType !== 'IRM' ? row?.rank : ''
                if (isEventRanking) {
                    let irm = row?.rk_IRM ? <SportCode discipline={discipline} entity='@IRM' code={row?.rk_IRM} abbr={true} /> : <></>
                    rank = row?.rk_IRM ? irm : row?.rank;
                } else if (isPoolStandings && ['WPO', 'FBL', 'BKB', 'HBL'].includes(discipline)) {
                    let irm = row?.irm ? <SportCode discipline={discipline} entity='@IRM' code={row?.irm} abbr={true} /> : <></>
                    rank = row?.irm ? irm : row?.rank;
                }
                return rank
            }
        }
    )
}

export function ColumnRankNoType({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-5 text-nowrap',
    label = 'HeaderRank'
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'sortOrder',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'RankNoType',
            Cell: (props) => {
                return props.cell.row.original.resultRank
            }
        }
    )
}

export function ColumnBibStatus({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-5 text-nowrap',
    label = 'HeaderBib',
    expecialCase = false,
    remove = false,
    accessor = "bib"
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: accessor,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Bib',
            remove: remove,
            Cell: (props) => {
                let rsc = RscFromStore()
                let discipline = getRscObject(rsc).discipline
                const row = props.cell.row.original
                const playerStatus = row?.eventUnitEntries?.find(e => e?.eue_code === 'STATUS')?.eue_value;
                const bib = (expecialCase && row.bib > 99999) ? '' : row.bib



                return playerStatus ? <SportCode discipline={discipline} entity='@AthleteStatus' code={playerStatus} abbr={true} /> : bib
            }
        }
    )
}

export function ColumnBib({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-5 text-nowrap',
    label = 'HeaderBib',
    expecialCase = false,
    remove = false,
    accessor = "bib"
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: accessor,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Bib',
            remove: remove,
            Cell: (props) => {
                const row = props.cell.row.original
                return (expecialCase && row.bib > 99999) ? '' : row.bib
            }
        }
    )
}

export function ColumnSortOrder({
    disableSort = false,
    className = 'd-none d-sm-table-cell ',
    headerClassName = 'd-none d-sm-table-cell w-5',
    label = 'HeaderSortOrder'
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'sortOrder',
            disableSortBy: disableSort,
            className: className,
            headerClassName: headerClassName,
            id: 'SortOrder',
        }
    )

}


export function ColumnNoc({

    disableSort = false,
    className = 'text-start d-none d-md-table-cell ',
    headerClassName = 'text-start d-none d-md-table-cell w-5 align-middle',
    label = 'HeaderNOC',
    remove = false,
    longDesc = false
}) {

    const competition = CompetitionFromStore();
    if (isParalympic(competition) && label === 'HeaderNOC') {
        label = 'HeaderNPC';
    }

    if (isParalympic(competition) && label === 'HeaderCountryNOC') {
        label = 'HeaderCountryNPC';
    }

    return (
        {
            Header: <Label data={label} />,
            id: 'NOC',
            accessor: 'participant.organisation.code',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            remove: remove,
            Cell: (props) => {
                const row = props.cell.row.original
                let data
                if (row?.athletes) {
                    data = row?.athletes?.find(x => x !== undefined)?.participant?.organisation
                } else {
                    data = row?.participant?.organisation
                }
                return (<Noc {...data} showLongDesc={longDesc} />)
            }
        }
    )

}

export function ColumnName({
    disableSort = false,
    className = 'text-start',
    headerClassName = 'text-start align-middle',
    label = '-',
    hideNoc = false,
    noLink = false,
    showGuide = false,
    remove = false,
}) {


    return (
        {
            Header: (props) => {
                const row = props?.data[0]

                let lbl
                if (label !== '-') {
                    lbl = label
                } else {
                    lbl = row?.participant?.__typename === 'Person' ? 'HeaderName' : 'HeaderTeam'
                }

                return (
                    <Label data={lbl} />
                )
            },
            accessor: (props) => (props?.participant?.name?.toUpperCase()),
            id: 'Name',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            hideNoc: hideNoc,
            noLink: noLink,
            showGuide: showGuide,
            remove: remove,
            Cell: (props) => {
                const { mirs_discipline } = useUrlFriendlyToParameters()
                const row = props.cell.row.original
                let data;
                let guide;
                let medicalClass;
                if (row?.athletes) {
                    data = row?.athletes?.find(x => x !== undefined)?.participant // revisar si es necesario o ya no se usa?
                } else {
                    data = row?.participant
                }
                if (row?.guide) {
                    guide = row?.guide
                }
                if (Array.isArray(row?.teamAthletes) && row?.teamAthletes.length === 1) {
                    medicalClass = row?.disciplineClass;
                } else {
                    //medicalClass = row?.participant?.medicalClass;
                }
                let competitorPlace;
                competitorPlace = row?.team_code ? row?.team_code : row?.athlete_code
                return (
                    <>
                        {(competitorPlace?.includes('NOAWARD'))
                            ? <SportCode discipline={mirs_discipline} entity='@CompetitorPlace' code={competitorPlace} />
                            : <Competitor
                                hidePicture={true}
                                hideNoc={hideNoc}
                                nolink={noLink}
                                {...data}
                                guide={guide}
                                showGuide={showGuide}
                                medicalClass={medicalClass}
                            />}
                    </>
                )
            }
        }
    )
}

export function ColumnNameH2H({
    disableSort = true,
    className = 'text-start',
    headerClassName = 'text-start',
    label = 'HeaderName',
    showCaptain = false,
    showCaptainAbbr = false,
    showDisciplineClass = true,
    showSuspendedCode = false,
    showStarter = false,
    hideNoc = false,
    remove = false
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'athlete.familyName',
            id: 'Name',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            showCaptain: showCaptain,
            showCaptainAbbr: showCaptainAbbr,
            showSuspendedCode: showSuspendedCode,
            showStarter: showStarter,
            hideNoc: hideNoc,
            remove: remove,
            Cell: (props) => {
                return (
                    props.cell.row.original.title ? props.cell.row.original.title
                        :
                        <>
                            <Competitor
                                {...props.cell.row.original?.athlete}
                                //{...props.cell.row.original}

                                eventUnitEntries={props.cell.row.original?.eventUnitEntries}
                                hidePicture={true}
                                showCaptain={showCaptain}
                                showCaptainAbbr={showCaptainAbbr}
                                medicalClass={showDisciplineClass ? props.cell.row.original?.medicalClass : ''}
                                showSuspendedCode={showSuspendedCode}
                                showStarter={showStarter}
                                hideNoc={hideNoc}
                            />
                        </>
                );
            }
        }
    )
}

export function ColumnTeamComponents({
    disableSort = false,
    className = 'text-start',
    headerClassName = 'text-start',
    label = 'HeaderName',
    hideNoc = false
}) {
    return (
        {
            Header: (props) => {
                const row = props?.data[0]

                let lbl
                if (label !== 'HeaderName') {
                    lbl = label
                } else {
                    lbl = row?.participant?.__typename === 'Person' ? 'HeaderName' : 'HeaderTeam'
                }
                return (
                    <Label data={lbl} />
                )
            },
            accessor: (props) => (props?.participant?.name.toUpperCase()),
            id: 'TeamComponents',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            hideNoc: hideNoc,
            Cell: (props) => {
                const row = props.cell.row.original
                return (
                    <Competitor hidePicture={true} hideNoc={hideNoc} {...row} />
                )
            }
        }
    )
}

export function ColumnTeamOrDuetsComponents({
    disableSort = false,
    className = 'text-start',
    headerClassName = 'text-start',
    label = 'HeaderDuet',
    hideNoc = false,
    isTeam = true
}) {
    if (isTeam) {
        label = 'HeaderTeam'
    }
    return (
        {
            Header: <Label data={label} />,
            accessor: (props) => (props?.participant?.name.toUpperCase()),
            id: 'Name',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            hideNoc: hideNoc,
            Cell: (props) => {
                const row = props.cell.row.original
                let teamOrDuet;
                if (isTeam) {
                    teamOrDuet = row?.participant
                } else {
                    teamOrDuet = row
                }
                return (
                    <Competitor hidePicture={true} hideNoc={hideNoc} {...teamOrDuet} />
                )
            }
        }
    )
}

export function ColumnOrganisation({

    disableSort = false,
    className = 'text-start ',
    headerClassName = 'text-start  w-5',
    label = 'Organization',
    remove = false,
    onlyShortName = false
}) {
    return (
        {
            Header: <Label data={label} />,
            id: 'Organisation',
            accessor: 'participant.organisation.code',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            remove: remove,
            Cell: (props) => {
                const row = props.cell.row.original
                let data = row?.organisation
                return (<Organisation onlyShortName={onlyShortName} {...data} />)
            }
        }
    )

}



export function ColumnWarnings({
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = '',
    remove = false
}) {
    return (
        {
            remove: remove,
            Header: (label === '') ? '' : <Label data={label} />,
            className: className,
            headerClassName: headerClassName,
            accessor: 'sortOrder',
            id: 'Warnings',
            Cell: (props) => {
                const row = props.cell.row.original;
                return (
                    row?.extendedResults && row?.participant?.code
                        ? <CellCardsFalseStart extendedResults={row?.extendedResults} participant={row?.participant?.code}></CellCardsFalseStart>
                        : ''
                )
            }
        }
    )
}

export function ColumnResult({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10 ',
    label = 'HeaderResult',
    remove = false,
    hideIrm = false
}) {

    return (
        {
            Header: <Label data={label} />,
            accessor: (props) => { return props.sortOrder },
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: 'Result',
            remove: remove,

            Cell: (props) => {
                let rsc = RscFromStore()
                let discipline = getRscObject(rsc).discipline
                let rowNumberIrm = findArray(props.cell.row.original.extendedResults, { er_code: ['IRM_LAP'] })
                let numberIrm = rowNumberIrm?.er_value || ''
                let resultIrm = (props.cell.row.original.resultIrm)

                let irmObject = {}
                switch (resultIrm) {
                    case 'DNF':
                        irmObject = <><SportCode discipline={discipline} entity='@IRM' code={resultIrm} abbr={true} isAddLegend={true} />{numberIrm}</>
                        break;
                    case 'LAP':
                        irmObject = <>{numberIrm}<SportCode discipline={discipline} entity='@IRM' code={resultIrm} abbr={true} isAddLegend={true} /></>
                        break;
                    default:
                        irmObject = <SportCode discipline={discipline} entity='@IRM' code={resultIrm} abbr={true} isAddLegend={true} related={resultIrm} />
                        break;
                }
                irmObject = hideIrm ? <></> : irmObject;
                return (
                    props.cell.row.original.resultType === 'IRM'
                        ? irmObject
                        : props.cell.row.original.resultType === 'TIME' && props.cell.row.original.unchecked === 'Y' ? `(${props.cell.row.original.resultData})` : props.cell.row.original.resultData
                )
            },
        }
    )
}

export function ColumnDifference({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderTimeBehind'
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'diff',// accessor is the "key" in the data 
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Diff',
            Cell: (props) => (
                //Si mandas todas las propiedades de la fila como esta cambia hace que se repinte 
                <CellDiff node={props.cell.row.original} ></CellDiff>

            )
        }
    )
}

export function ColumnPoints({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderPoints'
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'SortOrder',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: 'Points',
            Cell: (props) => {
                let extendedResult = findArray(props.cell.row.original.extendedResults, { er_code: ['PTS'] });
                if (extendedResult) {
                    return (extendedResult.er_value)
                }
            }
        }
    )
}

export function ColumnRecords({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-5 align-middle',
    remove = false,
    label = ''
}) {
    return (
        {
            //Header: 'Ghost',
            Header: <Label data={label} />,
            remove: remove,
            accessor: 'recordIndicators',// accessor is the "key" in the data 
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: 'Records',
            Cell: (props) => (
                props.cell.row.original.recordIndicators
                    ? props.cell.row.original.recordIndicators.filter(row => row.ri_order === 1).map((val) => {
                        return ((val.ri_equalled === 'Y' ? '=' : '') + val.ri_recordtype)
                    })
                    : ''
            )
        }
    )
}

export function ColumnQualification({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-5',
    remove = false
}) {
    return (
        {
            remove: remove,
            accessor: 'qualificationMark',// accessor is the "key" in the data 
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'QualMark',
        }
    )
}

export function ColumnMove({
    disableSort = true,
    className = 'text-center',
    headerClassName = 'text-center w-5',
    type = '',
    remove = false,
    currentLeg = '-'
}) {
    return (
        {
            Header: () => (<><FontAwesomeIcon icon={faArrowUp} /> <FontAwesomeIcon icon={faArrowDown} /></>),
            accessor: (props) => {
                let currentSplit = props.currentSplit === '999' ? props.finalSplit : props.currentSplit
                let value = '';
                let out = '';
                switch (type) {
                    case 'extendedResults':
                        value = findArray(props?.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [currentSplit] })
                        out = value.er_move
                        break;
                    case 'extendedResultsSAL':
                        value = findArray(props?.extendedResults, { er_code: ['MARK'], er_pos: [currentLeg] })
                        out = value.er_move
                        break;
                    case 'cumulativeResults':
                        value = findArray(props?.extendedResults, { er_code: ['MOVEMENT'] })
                        out = value.er_value
                        break;
                    default:
                        value = findArray(props?.resultAnalysis?.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [currentSplit] })
                        out = value.er_move
                        break;
                }
                //if (type === 'extendedResults') {
                //    value = findArray(props?.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [currentSplit] })
                //} else {
                //    value = findArray(props?.resultAnalysis?.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [currentSplit] })
                //}
                return (out)
            },
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Move',
            remove: remove,
            Cell: (props) => (
                <Movement move={props.value} />
            )


        }
    )
}

export function ColumnExpander({
    className = 'text-center',
    headerClassName = 'text-center expander  w-5',
    type = '',
    idNode = '',
    erCode = 'INTERMEDIATE',
    expandIrm = false,
    allExpanded = true,
    remove = false,
    isPoolStandings = false
}) {
    const competition = CompetitionFromStore();
    const iconOpen = competition === 'EG2023' ? faMinusCircle : faCaretDown;
    const iconClose = competition === 'EG2023' ? faPlusCircle : faCaretRight;
    return (
        {
            Header: ({ getToggleAllRowsExpandedProps, isAllRowsExpanded }) => (
                allExpanded && <span {...getToggleAllRowsExpandedProps()}>
                    {isAllRowsExpanded ? (
                        <FontAwesomeIcon className="font-icon" icon={iconOpen} />
                    ) : (
                        <FontAwesomeIcon className="font-icon" icon={iconClose} />
                    )}
                </span>
            ),
            id: "Expander",
            className: className,
            headerClassName: headerClassName,
            disableSortBy: true,
            remove: remove,
            accessor: (d) => {
                let sw = false;
                const discipline = getRscObject(RscFromStore()).discipline
                switch (type) {
                    case 'extendedResults':
                        if ((d.extendedResults && d.extendedResults.length > 0)
                            && (d.extendedResults.filter(row => row.er_code === erCode).length > 0)
                            && (d.resultType !== 'IRM' || (d.resultType === 'IRM' && expandIrm) || d.resultIrm === 'DNF' || d.resultIrm === 'DSQ')
                        ) {
                            sw = true
                        }
                        break;
                    case 'alwaysTrue': // no se mostraria con DNS y DQB
                        if (d.resultType !== 'IRM'
                            || (d.resultType === 'IRM' && expandIrm)
                            || d.resultIrm === 'DNF'
                            || (d.resultIrm === 'WD' && ['DIV'].includes(discipline))
                            || d.resultIrm === 'DSQ') {
                            sw = true;
                        }
                        break;
                    case 'alwaysTrueTri': // no se mostraria con DNS y DQB
                        if (d.resultType !== 'IRM'
                            || (d.resultType === 'IRM' && expandIrm)
                            || d.resultIrm === 'DNF'
                            || (d.resultIrm === 'WD' && ['DIV'].includes(discipline))
                            || d.resultIrm === 'DSQ'
                            || d.resultIrm === 'LAP') {
                            sw = true;
                        }
                        break;
                    case 'alwaysTrue2':
                        const isIrm = (d?.resultType?.includes("IRM"))
                        if (!isIrm
                            || (isIrm && d.resultIrm !== 'DQB' && !isPoolStandings && !['WPO'].includes(discipline))
                        ) {
                            sw = true;
                        }
                        break;
                    case 'resultAnalysis':

                        if ((d.resultAnalysis && d.resultAnalysis.extendedResults.length > 0)
                            && (d.resultAnalysis.extendedResults.filter(row => row.er_code === erCode).length > 0)
                            && (d.resultType !== 'IRM' || (d.resultType === 'IRM' && expandIrm) || d.resultIrm === 'DNF' || d.resultIrm === 'DSQ')
                        ) {
                            sw = true
                        }
                        break;
                    case 'eventRanking':
                        const rsc = RscFromStore();
                        if ((d.rk_IRM !== 'DSQ' && d.rk_IRM !== 'DQB' && d.athlete_code !== 'NOAWARD' && d.team_code !== 'NOAWARD')
                            || /GRY.5AA-.+/.test(rsc)
                            || (d.rk_IRM !== 'DQB' && /GRY.+/.test(rsc))
                            || (d.rk_IRM !== 'DQB' && /WPO.+/.test(rsc))
                            || (d.rk_IRM !== 'DQB' && /DIV.+/.test(rsc))
                        ) {
                            sw = true;
                        }
                        break;
                    case 'esl':
                        if (d.extCompetitor) {
                            sw = true;
                        }
                        break;
                    case 'participant':
                        if (d.participant) {
                            sw = true;
                        }
                        break;
                    default:
                        sw = true;
                        break;
                }


                let spanId = idNode === 'athlete' ? d?.athlete?.code : idNode ? d[idNode] : d?.participant?.code
                spanId = spanId ? spanId : d.sortOrder
                return ({

                    rowSpanId: spanId,
                    rowCanExpand: sw
                    /*
                                            (type === 'extendedResults')
                                                ? d.extendedResults && d.extendedResults.length > 0
                                                    ? d.extendedResults.filter(row => row.er_code === erCode).length > 0 ? true : false
                                                    : false
                                                : (type === 'alwaysTrue')
                                                    ? true
                                                    : (d.resultAnalysis && d.resultAnalysis.extendedResults && d.resultAnalysis.extendedResults.length > 0
                                                        ? (d.resultAnalysis.extendedResults.filter(row => row.er_code === erCode).length > 0 ? true : false)
                                                        : false)
                                    */
                })

            },
            Cell: (props) => (
                props.value && props.value.rowCanExpand ? (
                    <span {...props.row.getToggleRowExpandedProps()}>
                        {props.row.isExpanded ? (
                            <FontAwesomeIcon className="font-icon row-expander-icon" icon={iconOpen} />
                        ) : (
                            <FontAwesomeIcon className="font-icon row-expander-icon" icon={iconClose} />
                        )}
                    </span>
                ) : (<span></span>)
            )


        }
    )
}

export function ColumnCompensation({
    disableSort = true,
    className = 'text-center',
    headerClassName = 'text-end w-10',
    label = 'HeaderCompensationTime'
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'SortOrder',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Compensation',
            Cell: (props) => {
                let extendedResult = findArray(props.cell.row.original.extendedResults, { er_code: ['COMPENSATION'] });
                if (extendedResult) {
                    return (extendedResult.er_value)
                }
            }
        }
    )
}

export function ColumnPty({
    disableSort = true,
    className = 'text-right',
    headerClassName = 'text-right w-10',
    label = 'HeaderPty',
    accessor = 'pty'
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: accessor,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Pty',
            Cell: (props) => {
                return props.cell.row.original.pty
            }
        }
    )
}

///TEST
export function ColumnEventUnitEntries({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderEventUnitEntries',
    code = ""
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'eventUnitEntries',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: code,
            Cell: (props) => (
                props.cell.row.original.eventUnitEntries
                    ? props.cell.row.original.eventUnitEntries.filter(row => row.eue_code === code).map((val) => { return (val.eue_value) })
                    : ''
            )
        }
    )
}

export function ColumnIrmOrValue({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-5',
    label = 'HeaderPTS',
    id = 'result',
    isPoolStandings = false,
    remove = false
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'eventUnitEntries',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: id,
            remove: remove,
            Cell: (props) => {
                const row = props.cell.row.original
                const discipline = getRscObject(RscFromStore()).discipline
                let result = '';
                if (isPoolStandings && '|WPO|'.includes(discipline) && row?.resultType === 'IRM') {
                    result = ''
                } else if (row?.resultType === 'IRM_POINTS') {
                    result = (<>
                        <div className='tex-end'>
                            {row?.resultData}
                        </div>
                        <div className='tex-end'>
                            <SportCode discipline={discipline} entity='@IRM' code={row?.resultIrm} abbr={true} />
                        </div>
                    </>);
                } else if (row?.resultType === 'IRM' && row.irm !== undefined) {
                    result = <SportCode discipline={discipline} entity='@IRM' code={row?.irm} abbr={true} />;
                } else if (row[id] !== undefined) {
                    result = row[id];
                }
                return (
                    result
                )
            }
        }
    )
}

export function ColumnRankOws({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-5 text-nowrap',
    label = 'HeaderRank'
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'rank',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Rank',
            Cell: (props) => {
                let row = props.cell.row.original
                return (
                    (row.resultType !== 'IRM' && row.resultIrm !== 'REL' && row.resultIrm !== 'OTL')
                        ? <CellRank node={props.cell.row.original} ></CellRank>
                        : row.resultType === 'REL' || row.resultType === 'IRM_TIME' || row.resultType === 'IRM'
                            ? row?.resultIrm
                            : ''
                )
            },
        }
    )
}

export function ColumnResultOWS({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderResult'
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'SortOrder',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: 'Result',

            Cell: (props) => {
                return (
                    (props.cell.row.original.resultType !== 'IRM')
                        ? props.cell.row.original.resultData
                        : ''
                )
            }
        }
    )
}

export function ColumnDifferenceOws({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderTimeBehind'
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'diff',// accessor is the "key" in the data 
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Diff',
            Cell: (props) => {
                let row = props.cell.row.original
                return (
                    (row.resultType !== 'IRM' && row.resultIrm !== 'REL' && row.resultIrm !== 'IRM_TIME')
                        ? <CellDiffOws node={props.cell.row.original} ></CellDiffOws>
                        : ''
                )
            },
        }
    )
}

export function ColumnSportClass({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderMedical'
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'disciplineClass.classCode',
            id: 'SportClass',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            Cell: (props) => {
                let row = props.cell.row.original
                let medicalClass = row?.disciplineClass

                return medicalClass && <abbr title={medicalClass?.description}>{medicalClass?.classCode}</abbr>
            }
        }
    )
}

export function ColumnGender({
    disableSort = true,
    className = 'text-start',
    headerClassName = 'text-start w-10',
    label = 'HeaderGender'
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'athlete.personGender.code',
            id: 'Gender',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            Cell: (props) => {
                let row = props.cell.row.original
                let gender = row?.athlete?.personGender

                return gender && <abbr title={gender?.description}>{gender?.code}</abbr>
            }
        }
    )
}

export function ColumnHorse({
    disableSort = false,
    className = 'text-start',
    headerClassName = 'text-start',
    label = 'HeaderHorse',
    remove = false
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: (props) => (props?.horse?.name?.toUpperCase()),
            id: 'Horse',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            remove: remove,
            Cell: (props) => {
                const row = props.cell.row.original;
                return (<Horse {...row?.horse} />);
            }
        }
    )
}


export function ColumnAthleteHorse({
    disableSort = false,
    className = 'text-start',
    headerClassName = 'text-start',
    label = 'HeaderAthleteHorse',
    remove = false
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: (props) => (props?.participant?.name?.toUpperCase()),
            id: 'AthleteHorse',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            remove: remove,
            Cell: (props) => {
                const row = props.cell.row.original;
                return (
                    <>
                        <Competitor hidePicture={true} hideNoc={false} nolink={false}  {...row?.participant} />
                        <Horse {...row?.horse} />
                    </>
                );
            }
        }
    )
}



export function ColumnExtendedResult({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-5',
    label = 'HeaderNone',
    remove = false,
    id = 'er',
    code = '',
    type = 'ER',
    dataSource = 'er_value'
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: (props) => {
                const er = props?.extendedResults?.find(er => er?.er_code === code && er?.er_type === type);
                return er ? er[dataSource] : '';
            },
            id: id,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            remove: remove,
            Cell: (props) => {
                const row = props.cell.row.original;
                const er = row?.extendedResults?.find(er => er?.er_code === code && er?.er_type === type);
                return er ? er[dataSource] : '';
            }
        }
    )
}


export function ColumnPosition({
    disableSort = true,
    className = 'text-start',
    headerClassName = 'text-start w-10',
    label = 'HeaderPosition',
    code = 'Position'
}) {

    return (
        {
            Header: <Label data={label} />,
            accessor: 'functionDescription',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: code,
            Cell: (props) => {
                const { breakPoint } = useViewport();
                let position = (breakPoint === "sm" || breakPoint === "xs") ? props.cell.row.original.functionCode : props.cell.row.original.functionDescription
                return (position)
            }
        }
    )
}